module.exports = __webpack_public_path__ + "img/check.1dcae4d8.png";